export function getUrlPath(tournament, match, desc) {
    let url = null;

    try {
        desc = desc.replace(/-/g, 'vs').replace(/\s+/g, '-').replace(/\//g, '-');
        url = `${tournament.urlPath}/${desc}_${tournament.uniqueId}_${match.p}_${match.a}`;
        return url.toLocaleLowerCase();
    } catch(err) {
        console.error(err);
        return url;
    }
}
